import { useState } from "react";
import { Link, Navigate, useNavigate, useSearchParams } from "react-router";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { CampoSenha } from "@/components/shared/campo-senha";
import { Marca } from "@/components/shared/marca";
import { useAuth } from "@/lib/auth-context";
import { mensagemDeErro } from "./mensagem-de-erro";

export default function LoginPage() {
  const { signIn, session, loading } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [aSubmeter, setASubmeter] = useState(false);

  const destino = params.get("next") ?? "/";

  if (!loading && session) return <Navigate to={destino} replace />;

  async function aoSubmeter(e: React.FormEvent) {
    e.preventDefault();
    setASubmeter(true);
    const { error } = await signIn(email, password);
    setASubmeter(false);

    if (error) {
      toast.error(mensagemDeErro(error, "login"), { duration: 8000 });
      return;
    }
    void navigate(destino, { replace: true });
  }

  return (
    <div className="flex min-h-svh items-center justify-center p-6">
      {/* Caixa e logótipo maiores, e o lema do produto (14/09, slide 5). */}
      <Card className="w-full max-w-md">
        <CardHeader>
          {/* O logo em vez do título: é a primeira coisa que alguém vê do
              produto, e "TGT · PMI" é o nome do projeto, não o do produto. */}
          <Marca altura="h-14" className="mx-auto mb-2" />
          <CardTitle className="sr-only">PM ONE</CardTitle>
          <CardDescription className="text-center">
            One Platform. One Source of Truth. Infinite Possibilities.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={aoSubmeter} className="grid gap-4">
            <div className="grid gap-2">
              <Label htmlFor="email">E-mail</Label>
              <Input
                id="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="password">Palavra-passe</Label>
              <CampoSenha
                id="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <Button type="submit" disabled={aSubmeter}>
              {aSubmeter ? "A entrar…" : "Entrar"}
            </Button>
            <p className="text-muted-foreground text-center text-sm">
              Sem conta?{" "}
              <Link to="/cadastro" className="underline underline-offset-4">
                Registar
              </Link>
            </p>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
